import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme: any) => ({
  transportListPanel: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr ",
    gap: "100px",
    width: "100%",
    overflowX: "auto",

    [theme.breakpoints.down("xl")]: {
      gap: "24px",
    },

    [theme.breakpoints.down("lg")]: {
      gap: "24px",
    },

    [theme.breakpoints.down("md")]: {
      gap: "48px",
    },

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      display: "flex",
      gap: "24px",
    },
  },

  transportListItem: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    padding: "24px 48px",
    backgroundColor: "rgba(28, 30, 31)",
    borderRadius: 16,
    border: "1px solid #000000",
    boxSizing: "border-box",

    "& p": {
      fontFamily: "Philosopher",
      fontWeight: 900,
      color: "#FFFFFF",
    },

    [theme.breakpoints.down("lg")]: {
      padding: "24px 24px",
    },
  },

  transportListItemHeader: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    height: 36,
    alignItems: "center",
  },
  transportListItemOwnLabel: {
    display: "flex",
    gap: 8,
    alignItems: "center",

    "& p": {
      fontFamily: "Philosopher",
      fontWeight: 700,
      color: "#FFFFFF",
    },
  },
  transportListItemInfo: {
    display: "flex",
    gap: 24,
  },
  transportListItemDetail: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },

  transportListItemImage: {
    width: 80,
    height: 80,
    borderRadius: 8,
  },

  transportListItemCost: {
    display: "flex",
    alignItems: "center",
    gap: 8,

    "& img": {
      width: 24,
      height: 24,
    },
  },

  finishTravelButton: {
    backgroundColor: "#1c93f4e3",
    color: "#FFFFFF",
    borderRadius: 8,
    padding: "4px 8px",
    fontFamily: "Philosopher",
    fontWeight: 700,
    fontSize: 12,
    textTransform: "none",
    border: "none",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor: "#1c93f459",
    },
    "&:disabled": {
      backgroundColor: "#FFCCCC",
      cursor: "not-allowed",
    },
  },
}));

export default styles;
